<template>
  <div class="partners">
    <div class="core">
      <div class="link-top"></div>
      <div class="tit">{{ $t("home.partners") }}</div>
      <div class="link-top"></div>
    </div>

    <div class="center">
      <div class="partner partner1" v-for="(item,index) in imgUrl.rows" :key="index"> 
        <img :src="item.images" alt="">
      </div>
    </div>
  </div>
</template>

<script>
// import { GetPartnerList } from "@/assets/server/api.js";
export default {
  data() {
    return {
      imgUrl:[],
    };
  },
  created() {
   // this.GetPartnerList();
  },
  mounted() {},
  destroyed() {},
  methods: {
    // async GetPartnerList() {
    //   this.imgUrl = await GetPartnerList();
    //   // console.log(this.imgUrl.rows);
    // },
  },
};
</script>
<style lang="less">
.w1352 {
  width: 1200px;
  margin: 0 auto;
}
.w1300 {
  width: 67%;
  margin: 0 auto;
}
@keyframes showBottom {
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes hideBottom {
  to {
    opacity: 0;
    transform: translateY(100px);
  }
}
</style>
<style lang="less" scoped>
@keyframes showLeft {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes showRight {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes hideLeft {
  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}
@keyframes hideRight {
  to {
    opacity: 0;
    transform: translateX(100px);
  }
}
@keyframes scaleUp-animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scaleDown-animation {
  0% {
    transform: scale(1.25);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.25);
  }
}
.scale {
}
.scale :hover {
  transform: rotate(7deg);
  -ms-transform: rotate(7deg); /* IE 9 */
  -moz-transform: rotate(7deg); /* Firefox */
  -webkit-transform: rotate(7deg); /* Safari 和 Chrome */
  -o-transform: rotate(7deg); /* Opera */
  color: red;
}

.partners {
  text-align: center;
  width: 100%;
  background: linear-gradient(180deg, #f2f5f9 0%, #f3f5f9 30%, #ffffff 41%);
  height: 400px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  margin-bottom: 117px;
  .core {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    text-align: center;
    .link-top {
      justify-content: center;
      width: 501px;
      margin-top: 14.5px;
      height: 1px;
      vertical-align: middle;
      background: #e8eaf2;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
    }
    .tit {
      width: 104px;
      height: 30px;
      font-size: 16px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #000000;
      line-height: 30px;
      -webkit-background-clip: text;
      // padding: 0 15px;
      margin: 0 48px;
      // box-sizing: border-box;
    }
  }
  .center {
    width: 1200px;
    height: 320px;
    margin: 0 auto;
    .partner {
      float: left;
      margin: 64px 20px 0 40px;
      width: 264px;
      height: 124px;
      // background: linear-gradient(
      //   180deg,
      //   #8277ff 0%,
      //   rgba(130, 119, 255, 0) 100%
      // );
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      filter: blur(undefinedpx);
      img{
        width: 186px;
        height: 70px;
      }
    }
    .partner1 {
      margin-left: 16px;
    } 
    .partner1:nth-child(9){
      margin-bottom: 267px;
    }
  }
}
</style>
